import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <motion.div className="fixed top-0 left-0 right-0 z-50 bg-rose-gold text-white py-1.5 px-2 md:py-2 md:px-4 text-center shadow-lg" initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-188">
      <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-0.5 sm:gap-2 text-[11px] leading-tight sm:text-sm md:text-base" animate={{
      scale: [1, 1.02, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-189">
        <span className="font-bold" data-id="element-190">
          <span className="sm:hidden" data-id="element-191">
            🚨 FÊTE DES MÈRES : Télécharge ton kit maintenant !
          </span>
          <span className="hidden sm:inline" data-id="element-192">
            🚨 FÊTE DES MÈRES DANS QUELQUES JOURS : Télécharge ton kit
            maintenant pour créer son cadeau ce soir !
          </span>
        </span>
        <span className="flex items-center gap-1 font-bold bg-white/25 rounded-full px-2 py-0.5 text-[11px] sm:text-sm" data-id="element-193">
          <ClockIcon className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-194" />
          {String(timeLeft.hours).padStart(2, '0')}:
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </motion.div>
    </motion.div>;
}